import React from 'react';
import {
    FaqA,
    FaqItem,
    FaqQ,
    FaqSection,
    FaqTitle,
    SectionTitle,
    StepCard,
    StepContent,
    StepDesc,
    StepNumberCircle,
    StepsContainer,
    StepTitle,
    Wrapper,
} from './styles';
import {useLandingContext} from "../../../Landing";

export default function StartGuide() {
    const {APP_DATA} = useLandingContext();

    const {howToStartTitle, faq, startSteps} = APP_DATA;

    return (
        <Wrapper>
            <SectionTitle>{howToStartTitle}</SectionTitle>
            <StepsContainer>
                {startSteps.map((item, index) => (
                    <StepCard key={index}>
                        <StepNumberCircle>{item.step}</StepNumberCircle>
                        <StepContent>
                            <StepTitle>{item.title}</StepTitle>
                            <StepDesc>{item.desc}</StepDesc>
                        </StepContent>
                    </StepCard>
                ))}
            </StepsContainer>

            <FaqSection>
                <FaqTitle>{APP_DATA.faqTitle}</FaqTitle>
                {faq.map((item, index) => (
                    <FaqItem key={index}>
                        <FaqQ>{item.q}</FaqQ>
                        <FaqA>{item.a}</FaqA>
                    </FaqItem>
                ))}
            </FaqSection>
        </Wrapper>
    );
}
